<template>
  <form>
    <ui-container>
      <ui-form-section :title="editMode ? 'Update Callback' : 'Add new Callback'" subtitle="Provide the main details of the Callback in this section." class="py-8 border-b">
        <ui-select-searchable
            v-if="editMode || !packageId"
            label="Package"
            v-model="form.package_id"
            :error="form.errors.get('package_id')"
            :search="searchPackages"
            class="col-span-12"
            no-search="Type to search packages..."
        ></ui-select-searchable>
        <ui-textarea label="Enter some information about the callback..." name="description" :error="form.errors.get('description')" v-model="form.description"></ui-textarea>
        <ui-date-picker label="Date" name="date" :error="form.errors.get('date')" v-model="form.date"></ui-date-picker>
      </ui-form-section>
    </ui-container>

    <ui-container class="py-4 flex justify-end space-x-6">
      <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
      <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
      <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
        {{ editMode ? 'Save' : 'Create' }}
      </ui-button-new>
    </ui-container>
  </form>
</template>

<script>
import { Callback, Package } from '@models'

export default {
  props: {
    item: Object,
    edit: Function,
    addItem: Function,
    removeItem: Function,
    packageId: null,
  },
  data () {
    const initialData = this.item
        ? this.item.getFormAttributes()
        : {}

    return {
      form: new Form(initialData, async (form) => {
        const data = form.export()

        if (!data.package_id && this.packageId) {
          data.package = { value: this.packageId }
          data.package_id = this.packageId
        }

        if (this.editMode) {
          await this.item.update(data)
          if (this.packageId && this.item.package_id !== parseInt(this.packageId, 10)) {
            this.removeItem(this.item)
          } else {
            this.edit(false)
          }

        } else {
          const callback = await Callback.create(data)
          this.addItem(callback, 0)

          form.reset()
        }
      }),
    }
  },
  computed: {
    editMode () {
      return !! this.item
    },
  },
  methods: {
    async searchPackages (query) {
      return await Package.search(query, true)
    },
  },
}
</script>
